var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#receipt_svg__clip0_61530_7503)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12h-1.5v1.5h1.5V12zM12.75 12h-6v1.5h6V12zM17.25 9h-1.5v1.5h1.5V9zM12.75 9h-6v1.5h6V9zM17.25 6H6.75v1.5h10.5V6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 1.5H5.25A1.502 1.502 0 003.75 3v18.75a.75.75 0 00.75.75h.75a.748.748 0 00.6-.3L7.5 20l1.65 2.2a.776.776 0 001.2 0L12 20l1.65 2.2a.775.775 0 001.2 0L16.5 20l1.65 2.2a.749.749 0 00.6.3h.75a.75.75 0 00.75-.75V3a1.502 1.502 0 00-1.5-1.5zm0 19l-1.65-2.2a.775.775 0 00-1.2 0l-1.65 2.2-1.65-2.2a.775.775 0 00-1.2 0l-1.65 2.2-1.65-2.2a.776.776 0 00-1.2 0l-1.65 2.2V3h13.5v17.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "receipt_svg__clip0_61530_7503"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgReceipt;